/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M24 23.479c5.348 0 9.654-5.248 9.654-11.74S32.241 0 24 0c-8.241.034-9.654 5.281-9.654 11.739 0 6.492 4.306 11.74 9.654 11.74zM5.735 41.407c0-.403 0-.134 0 0zm36.53.303c0-.101 0-.74 0 0zm-.034-.774c-.168-11.302-1.648-14.497-12.95-16.549 0 0-1.581 2.018-5.281 2.018s-5.281-2.018-5.281-2.018c-11.167 2.018-12.748 5.18-12.95 16.179-.034.908-.034.942-.034.841v1.177S8.426 48 24 48s18.265-5.416 18.265-5.416v-.874c0 .067 0-.067-.034-.774z"/>'
}
